import styled from 'styled-components';

export const Grid = styled.div`
  @media (max-width: 768px) {
    &.grid.medium-space {
      margin-top: 0;
    }
  }
`;
